// extracted by mini-css-extract-plugin
export default {"image-account":"AccountManagement_image-account__9MNPp","text-title":"AccountManagement_text-title__VSg4i","content":"AccountManagement_content__Kk2j7"};